import React from "react";
import { getCurrentUser } from "../auth";
import { auth } from "../services/firebase";
import { signOut } from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";

export default function SchoolHeader() {
  const navigate = useNavigate();
  const [q, setQ] = React.useState("");
  const user = getCurrentUser();
  let accent = "accent-gapan";
  try {
    const saved = localStorage.getItem("accentCampus");
    if (saved) accent = `accent-${String(saved).toLowerCase()}`;
    else if (user?.campus) accent = `accent-${String(user.campus).toLowerCase()}`;
  } catch (e) { /* ignore */ }
  return (
    <div className={`vms-school-header ${accent}`}>
      <div className="vms-school-header__inner" style={{ justifyContent: "space-between" }}>
        <Link to="/" className="d-flex align-items-center gap-3" style={{ textDecoration: "none" }}>
          <img src="/vmsc_logo.png" alt="VMSC" style={{ height: 36, borderRadius: 6 }} />
          <h1 className="vms-school-header__title" style={{ fontSize: "clamp(24px, 3vw, 36px)", margin: 0, color: "#2b1b00" }}>
            Village Montessori School and Colleges
          </h1>
        </Link>
        <div className="d-flex align-items-center gap-3" style={{ minWidth: 320 }}>
          <div className="d-none d-md-flex align-items-center" style={{ background: "rgba(255,255,255,0.85)", borderRadius: 20, padding: "6px 12px" }}>
            <i className="bi bi-search" style={{ color: "#6c757d" }}></i>
            <input
              placeholder="Search pages, students"
              aria-label="Search"
              value={q}
              onChange={e => setQ(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  const text = q.trim();
                  if (!text) return;
                  const lower = text.toLowerCase();
                  if (["finance","admin","collections","transactions"].some(k => lower.includes(k))) {
                    navigate("/finance");
                  } else if (["books"].some(k => lower.includes(k))) {
                    navigate("/books");
                  } else if (["uniforms"].some(k => lower.includes(k))) {
                    navigate("/uniforms");
                  } else if (["hr","payroll"].some(k => lower.includes(k))) {
                    navigate("/hr");
                  } else {
                    try { localStorage.setItem("globalStudentSearch", text); } catch (e) { void e; }
                    navigate("/sis/students");
                  }
                }
              }}
              style={{ border: "none", outline: "none", background: "transparent", marginLeft: 8, width: 220 }}
            />
          </div>
          <div className="d-flex align-items-center gap-2">
            <span style={{ color: "#2b1b00" }}>{user ? (user.username || user.email || "User") : "Guest"}</span>
            {user ? (
              <button
                className="btn btn-sm btn-outline-light"
                onClick={async () => {
                  try { await signOut(auth); } catch (e) { void e; }
                  try { localStorage.removeItem("user"); } catch (e) { void e; }
                  window.location.href = "/login";
                }}
              >
                Logout
              </button>
            ) : (
              <Link to="/login" className="btn btn-sm btn-outline-light">Login</Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
